import { ChangeEvent, useState } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { REJECT_REASON_MAX_LENGTH } from "./constants";

const REASON_ROWS = 3;
const REASON_PLACEHOLDER = "เช่น น้ำมันเครดิต KB03 ไม่ตรงกับสลิปบัตร";

interface RejectReasonPanelProps {
  isSending: boolean;
  onCancel: () => void;
  /** Called with the trimmed reason; never with a blank one. */
  onConfirm: (reason: string) => void;
}

/** ตีกลับ always carries a reason: the branch reads it on the red banner of its form. */
export default function RejectReasonPanel({
  isSending,
  onCancel,
  onConfirm,
}: Readonly<RejectReasonPanelProps>) {
  const [reason, setReason] = useState("");
  const [isReasonMissing, setReasonMissing] = useState(false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setReason(event.target.value);
    setReasonMissing(false);
  };
  const handleConfirm = () => {
    const trimmed = reason.trim();
    if (!trimmed) {
      setReasonMissing(true);
      return;
    }
    onConfirm(trimmed);
  };

  return (
    <Stack gap={1}>
      <Typography variant="body2" fontWeight={600}>
        เหตุผลที่ตีกลับ{" "}
        <Typography component="span" color="error.main">
          *
        </Typography>
      </Typography>
      <TextField
        multiline
        rows={REASON_ROWS}
        fullWidth
        value={reason}
        onChange={handleChange}
        placeholder={REASON_PLACEHOLDER}
        error={isReasonMissing}
        helperText={isReasonMissing ? "กรุณาระบุเหตุผลก่อนตีกลับ" : undefined}
        slotProps={{
          htmlInput: { "aria-label": "เหตุผลที่ตีกลับ", maxLength: REJECT_REASON_MAX_LENGTH },
        }}
      />
      <Stack direction="row" justifyContent="flex-end" gap={1}>
        <Button onClick={onCancel} disabled={isSending}>
          ยกเลิก
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirm} loading={isSending}>
          ยืนยันตีกลับ
        </Button>
      </Stack>
    </Stack>
  );
}
